import React, { useEffect, useContext } from 'react';

import FunctionsContext from '../contexts/FunctionsContext';

import Spinner from '../components/Spinner';

const Logout = () => {
  const { logout } = useContext(FunctionsContext);

  useEffect(() => {
    logout();
  }, [logout]);

  return (
    <Spinner overlay />
  );
};

export default Logout;
